$.fn.extend({
    inputNumberFormat: function (options) {
        this.defaultOptions = {
            decimal: 2,
            decimalAuto: 2,
            separator: ".",
            separatorAuthorized: [".", ","],
            allowNegative: false,
        };

        var settings = $.extend({}, this.defaultOptions, options);

        var matchValue = function (value, options) {
            var found = [];
            var regexp = "^[0-9]+$";
            found = value.match(regexp);
            return found;
        };

        var formatValue = function (value, options) {
            var formatedValue = value;
            if (!formatedValue) {
                return formatedValue;
            }
            if (formatedValue == "-") {
                return "";
            }
            return formatedValue;
        };

        return this.each(function () {
            var $this = $(this);

            $this.on("keypress", function (e) {
                if (e.ctrlKey) {
                    return;
                }

                if (e.key.length > 1) {
                    return;
                }

                var options = $.extend({}, settings, $(this).data());

                var beginVal = $(this).val().substr(0, e.target.selectionStart);
                var endVal = $(this)
                    .val()
                    .substr(e.target.selectionEnd, $(this).val().length - 1);
                var val = beginVal + e.key + endVal;

                if (!matchValue(val, options)) {
                    e.preventDefault();
                    return;
                }
            });

            $this.on("blur", function (e) {
                var options = $.extend({}, settings, $(this).data());

                $(this).val(formatValue($(this).val(), options));
            });

            $this.on("change", function (e) {
                var options = $.extend({}, settings, $(this).data());

                $(this).val(formatValue($(this).val(), options));
            });
            $this.on("paste", function (e) {
                var data = e.originalEvent.clipboardData.getData('Text');
                var parsed = parseInt(data)
                var $element = $(this);
                setTimeout(function () {
                    $element.val(parsed);
                  }, 100);
            });
        });
    },
});
